import type { SshConfig } from "./types"

export const fixedRemoteProjectID = "omm-test-vm"

export function sshHostname(target: string) {
  // Accepted SSH targets end with a hostname or user@hostname, never a remote
  // command. Strip shell quoting for display only; keep the saved target intact.
  return (
    (target.trim().split(/\s+/).at(-1) ?? "")
      .replace(/["'\\]/g, "")
      .split("@")
      .at(-1) ?? ""
  )
}

export function sshName(config: Pick<SshConfig, "name" | "target">) {
  return config.name || sshHostname(config.target)
}

export function sshDisplayName(config: SshConfig, remoteProjectLabel: string) {
  return config.id === fixedRemoteProjectID ? remoteProjectLabel : sshName(config)
}

export function sshDisplayPrompt(config: SshConfig, prompt: string, remoteProjectLabel: string) {
  if (config.id !== fixedRemoteProjectID) return prompt
  const target = config.target.trim().split(/\s+/).at(-1) ?? ""
  const host = sshHostname(config.target)
  if (!target || !host) return prompt
  return prompt.replaceAll(target, remoteProjectLabel).replaceAll(host, remoteProjectLabel)
}
